import React from 'react';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';

import { Panel } from '../../Panel/Panel';
import { useStyles } from '../useStyles';
import { PreliminaryInfoRow } from '../PreliminaryInfoRow/PreliminaryInfoRow';

function FlightCardPreliminaryInfo({ legs }) {
    const classes = useStyles();
    const { t: translate } = useTranslation();

    return (
        <Panel title={translate('flightPage.preliminaryInfo')} className="flight-info__panel  flight-info__panel--preliminary">
            <div className="flight-info__inner">
                <table className="flight-info__table">
                    <thead>
                        <tr>
                            <th className={classnames(classes.columnMain, classes.tableHeaderCell)}>{translate('flightPage.route')}</th>
                            <th className={classnames(classes.column, classes.tableHeaderCell)}>{translate('flightPage.version')}</th>
                            <th className={classnames(classes.column, classes.tableHeaderCell)}>{translate('flightPage.mtow')}</th>
                            <th className={classnames(classes.column, classes.tableHeaderCell)}>{translate('flightPage.upliftPlan')}</th>
                            <th className={classnames(classes.column, classes.tableHeaderCell)}>{translate('flightPage.upliftFact')}</th>
                            <th className={classnames(classes.column, classes.tableHeaderCell)}>{translate('flightPage.passengers')}</th>
                            <th className={classnames(classes.column, classes.tableHeaderCell)}>{translate('flightPage.load')}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {legs.map((data) => (
                            <PreliminaryInfoRow key={data.key} item={data.item} />
                        ))}
                    </tbody>
                </table>
            </div>
        </Panel>
    );
}

export { FlightCardPreliminaryInfo };
